
const moduleData = {
  id: "module-6",
  title: "Module 6",
  subtitle: "Strengthen Human values by destroying animal qualities and seeking Divine qualities in गृहस्थ(gṛhastha)  Āśrama",
   cardImage: "/enBanner/m6_banner.jpg",
  pdfPath: "/en/Modules/m6.pdf",
  audio: {
    title: "Vedic Chanting - Placeholder",
    audioUrl: "/en/Audio/m6.mp3",
    duration: "0:00"
  },
  video: {
    id: "g-g2_g_g_g_g"
  },
  hero: {
    title: "Module 6",
    subtitle: "Strengthen Human values by destroying animal qualities and seeking Divine qualities in गृहस्थ(gṛhastha)  Āśrama",
    description: "Content for this module is coming soon.",
    buttonText: "Explore",
    bgImage: "/enBanner/m6_banner.jpg",
    bgAlt: "Placeholder"
  },
  pages: [
    {
      pageId: 'definition',
      title: 'Definition',
      definition: {
        sectionLabel: "Definition",
        title: "What is Strengthen Human values by destroying animal qualities and seeking Divine qualities in गृहस्थ(gṛhastha)  Āśrama?",
        text: "Placeholder text.",
        quote: {
          sanskrit: "",
          meaning: "",
          origin: ""
        },
        description: "Placeholder description.",
        source: "",
        image: "",
        imageAlt: ""
      }
    },
    {
      pageId: 'quiz',
      title: 'Quiz',
      quiz: {
        questions: [
          {
            question: "Being married and living with the wife and children alone constitutes grihastha ashrama.",
            options: ["True", "False"],
            answer: "False, Grihastha ashrama involves treating all with equal consideration, gaining awareness of the world, acquainting oneself with the shastras, and fostering and protecting one's family with a sense of responsibility"
          },
          {
            question: "Grihastha is the chief stage, fostering the other three stages.",
            options: ["True", "False"],
            answer: "True, Grihastha supports dependants in all ways and is eligible to attain liberation if the prescribed Dharma is strictly followed"
          },
          {
            question: "In Gṛhastha Āśrama, wealth (Artha) should be acquired:",
            options: ["By any means", "Without concern for ethics", "In accordance with Dharma", "Only through inheritance"],
            answer: "In accordance with Dharma"
          },
          {
            question: "What is the significance of Yajnas in the life of a householder?",
            options: ["Yajnas are designed to lead one to the One who is unchanging and eternal", "Yajnas are performed to accumulate wealth", "Yajnas are rituals to honor only the deities", "Yajnas are performed to gain social status"],
            answer: "Yajnas are designed to lead one to the One who is unchanging and eternal"
          },
          {
            question: "What are the six daily duties of a Grihastha?",
            options: ["Snaanam, Sandhya, Japam, Homam, Puja, and Atithi Satkaram", "Snaanam, Sandhya, Japam, Homam, Puja, and Yoga", "Snaanam, Sandhya, Dhyanam, Homam, Puja, and Atithi Satkaram", "Snaanam, Sandhya, Japam, Homam, Puja, and Daana"],
            answer: "Snaanam, Sandhya, Japam, Homam, Puja, and Atithi Satkaram"
          },
          {
            question: "What does the term \"grihastha\" mean ?",
            options: [
              "Being married and living with the wife and children",
              "Treating all with equal consideration, gaining awareness of the world, acquainting oneself with the shastras, and fostering and protecting one's family with a sense of responsibility",
              "Living alone and practicing asceticism",
              "Accumulating wealth and material possessions"
            ],
            answer: "Treating all with equal consideration, gaining awareness of the world, acquainting oneself with the shastras, and fostering and protecting one's family with a sense of responsibility"
          },
        ]
      }
    },
    {
      pageId: 'feedback',
      title: 'Feedback',
      feedback: {}
    }
  ]
};

export { moduleData };
